import React, { useState, useEffect } from "react";
import { Sidebar } from "primereact/sidebar";

import { useNavigate } from "react-router-dom";
import { getLocalFranchiseUserInfo, getUserData } from "../utils/localStorage";

const CardData = [
  {
    id: 1,
    name: "Customers",
    backgroundImage: "Icons/profile.png",
    url: "/Customers",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 2,
    name: "Stock",
    backgroundImage: "warehouse/stocks.png",
    url: "/GarmentStock",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 3,
    name: "Report",
    backgroundImage: "images/summary.png",
    url: "/Reports-view",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 17,
    name: "WH Order Report",
    // receipt
    backgroundImage: "images/summary.png",
    url: "/WarehouseOrderStatusReport",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 4,
    name: "Analytics",
    backgroundImage: "images/graph.png",
    url: "/AnalyticsList",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 10,
    name: "Collection Report",
    backgroundImage: "images/summary.png",
    url: "/Reports",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 16,
    name: "Challan",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/ChallanList",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 13,
    name: "B2B Challan",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/B2BChallanList",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 14,
    name: "Rack Model",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/RackModel",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 5,
    name: "Order Delivered",
    backgroundImage: "warehouse/delivery-boy.png",
    url: "/OrderDelivered",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 7,
    name: "Old Order",
    backgroundImage: "images/garments.png",
    url: "/OldOrder",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 8,
    name: "Cash Book",
    backgroundImage: "images/summary.png",
    url: "/Cashbook",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 9,
    name: "Bulk Processing",
    backgroundImage: "images/cash-payment.png",
    url: "/BulkProcessingList",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 11,
    name: "W Notification",
    backgroundImage: "images/WhatsApplogo.png",
    url: "/Whatsapp-Notification",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 15,
    name: "Customer Feedback",
    backgroundImage: "Icons/profile.png",
    url: "/Customer-FeedBack",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 12,
    name: "Subscription & Packages",
    backgroundImage: "Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif",
    // url: '/Package-Log',
    url: "/Subscription-Package",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 6,
    name: "LogOut",
    backgroundImage: "Icons/logout.png",
    url: "/LogOut",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
];

export default function AdminMenu({ visible, setVisible }) {
  const navigate = useNavigate();
  const { brandProfileData, storeData, userProfileData, userProfileRole } =
    getUserData();

  const userRole = userProfileRole;

  const filteredCardData = CardData;

  const [franchiseUserInfoList, setFranchiseUserInfoList] = useState([]);

  const fetchLocalFranchiseUserInfo = async () => {
    const { franchiseUser } = await getLocalFranchiseUserInfo();
    if (franchiseUser && Object.keys(franchiseUser).length > 0) {
      setFranchiseUserInfoList(franchiseUser);
    } else {
      setFranchiseUserInfoList([]);
    }
  };

  useEffect(() => {
    fetchLocalFranchiseUserInfo();
  }, []);

  const renderCardItem = () => {
    return CardData?.map((item, index) => {
      const wareHouseModel = brandProfileData.wareHouseModel;

      const enabledAutoWhatsappNotification =
        brandProfileData.enabledAutoWhatsappNotification;
      const packageCarryForwardBrand = brandProfileData.packageCarryForward;
      const enabledB2BModel = brandProfileData.enabledB2BModel;
      const enabledRackModel = brandProfileData.enabledRackModel;
      const enabledCustomerAppBrand = brandProfileData.enabledCustomerApp;

      if (!enabledAutoWhatsappNotification && item.id === 11) return null;
      if (!enabledB2BModel && item.id === 13) return null;
      if (!enabledRackModel && userRole === "BY_ADMIN" && item.id === 14)
        return null;
      if (userRole === "BY_SUB_ADMIN_USER" && item.id === 1) return null;
      if (userRole === "BY_SUB_ADMIN_USER" && item.id === 3) return null;
      if (userRole === "BY_SUB_ADMIN_USER" && item.id === 10) return null;
      // Franchise Modal
      if (userRole === "BY_FRANCHISE_ADMIN" && item.id === 1) return null;
      if (userRole === "BY_FRANCHISE_ADMIN" && item.id === 7) return null;
      if (!enabledCustomerAppBrand && item.id === 15) return null;
      if (!wareHouseModel && item.id === 16) return null;
      if (
        item.id === 17 &&
        (userRole === "BY_FRANCHISE_ADMIN" || !wareHouseModel)
      ) {
        return null;
      }
      // if (!packageCarryForwardBrand && item.id === 12) return null;
      return (
        <div className="flex-1">
          <div className="flex-1  surface-0" style={{ "--surface-0": "#ccc" }}>
            <div style={{ height: 1 }}></div>
          </div>
          <div
            className="flex flex-row my-2 h-3rem cursor-pointer"
            onClick={() => {
              navigate(item.url);
              setVisible(!visible);
            }}
          >
            <div
              className="flex justify-content-center"
              style={{ flex: 1, alignSelf: "center" }}
            >
              <img
                src={item.backgroundImage}
                style={{ width: item.width, height: item.height }}
              />
            </div>
            <div style={{ flex: 2, alignSelf: "center" }}>
              <p className="text-xl font-medium">{item.name}</p>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      <Sidebar
        visible={visible}
        onHide={() => setVisible(false)}
        position="right"
        content={({ closeIconRef, hide }) => (
          <div className="min-h-screen flex relative lg:static surface-ground">
            <div
              id="app-sidebar-2"
              className="surface-section h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none"
              style={{ width: "280px" }}
            >
              <div className="flex flex-column h-full">
                <div
                  className="flex align-items-center justify-content-between px-2 pt-2 flex-shrink-0 surface-0"
                  style={{
                    "--surface-0": "#1752AA",
                  }}
                >
                  <div className="flex flex-1">
                    <div
                      className="flex align-items-center justify-content-center w-3 cursor-pointer"
                      onClick={() => navigate("/UserProfile")}
                      style={{
                        height: 65,
                        width: 65,

                        borderRadius: 50,
                        backgroundColor: "#fff",
                      }}
                    >
                      {storeData.logo ? (
                        <img
                          src={`data:image/png;base64,${storeData.logo}`}
                          style={{ width: 50, height: 50 }}
                        />
                      ) : (
                        <img
                          src={
                            userRole === "BY_RIDER"
                              ? "warehouse/delivery-boy.png"
                              : "warehouse/warehouse_2.png"
                          }
                          style={{ width: 50, height: 50 }}
                        />
                      )}
                    </div>
                    <div className="ml-2 w-9">
                      <p className="text-2xl font-medium text-white">
                        {userProfileData.firstName?.replace(/_/g, " ")}{" "}
                        {userProfileData.lastName?.substring(0, 6)}
                        {userProfileData.lastName?.length > 6 ? "..." : ""}
                      </p>
                      <p className="text-xl font-medium text-white">
                        {userRole === "BY_ADMIN"
                          ? "ADMIN"
                          : userRole === "BY_FRANCHISE_ADMIN"
                            ? "Franchise Admin"
                            : "SUB ADMIN"}{" "}
                        -
                        {userRole === "BY_FRANCHISE_ADMIN"
                          ? franchiseUserInfoList?.name
                              ?.replace(/_/g, " ")
                              .substring(0, 12)
                          : brandProfileData?.name
                              ?.replace(/_/g, " ")
                              .substring(0, 12)}
                        {userRole === "BY_FRANCHISE_ADMIN"
                          ? franchiseUserInfoList?.name?.length > 12
                            ? "..."
                            : ""
                          : brandProfileData?.name?.length > 12
                            ? "..."
                            : ""}
                      </p>
                      <p
                        className="text-md font-normal text-white"
                        style={{
                          wordWrap: "break-word",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {userRole === "BY_FRANCHISE_ADMIN"
                          ? franchiseUserInfoList.email
                          : brandProfileData.email}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="overflow-y-auto">{renderCardItem()}</div>
              </div>
            </div>
          </div>
        )}
      ></Sidebar>
    </div>
  );
}
